import React, { useEffect, useState } from "react";
import {
  Button,
  Heading,
  Loader,
  ScrollView,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  View,
  Icon,
  Alert,
  Text
} from "@aws-amplify/ui-react";
import "./Users.css";
import { Modal } from "react-bootstrap";
import { MdAssignment, MdAssignmentReturn, MdBlock, MdEdit, MdLock, MdLockOpen } from "react-icons/md";
import CreateUserForm from "./CreateUserForm";
import ModifyUserForm from "./ModifyUserForm";
import { blockUserAPI, getUsersListAPI, unblockUserAPI } from "../../data/api";
import { getUserRoleLabel } from "../../data/interfaces";
import { Link, NavLink, Navigate, useNavigate } from "react-router-dom";

export interface User {
  sub: string;
  username: string;
  name?: string;
  email?: string;
  role?: string;
  enabled?: boolean;
}

export interface UsersTableProps {
  users?: User[];
}

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  // create modal
  const [showCreateModal, setShowCreateModal] = useState(false);
  const closeCreateModal = () => setShowCreateModal(false);
  const openCreateModal = () => setShowCreateModal(true);

  // modify modal
  const [showModifyModal, setShowModifyModal] = useState(false);
  const closeModifyModal = () => setShowModifyModal(false);
  const openModifyModal = () => setShowModifyModal(true);
  const [modifyItem, setModifyItem] = useState({});

  const getUsersList = async () => {
    setLoading(true)
    setError(false);
    try {
      const usersList = await getUsersListAPI();
      setUsers(usersList)
      setLoading(false);
    } catch (e) {
      console.log('Could not load users list: ', e);
      setError(true);
      setLoading(false);
    }
  };

  const blockUser = async (username) => {
    setLoading(true);
    setError(false);
    try {
      await blockUserAPI(username);
      getUsersList()
    } catch (e) {
      console.log('Cannot block user: ', e);
      setLoading(false);
      setError(true);
    }
  };

  const unblockUser = async (username) => {
    setLoading(true);
    setError(false);
    try {
      await unblockUserAPI(username);
      getUsersList()
    } catch (e) {
      console.log('Cannot unblock user: ', e);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    getUsersList();
  }, []);

  return (
    <View maxWidth="100%" padding="0rem" minHeight="100vh">
      <View
        backgroundColor="var(--amplify-colors-white)"
        borderRadius="6px"
        maxWidth="100%"
        padding="1rem"
      >
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
          <h2>Gestione utenti</h2>
          <Button onClick={openCreateModal}>Crea nuovo utente</Button>
        </div>
        <br/>
        <Modal show={showCreateModal} onHide={closeCreateModal}>
          <Modal.Header closeButton>
            <Modal.Title>Creazione utente</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CreateUserForm onCreate={() => {closeCreateModal(); getUsersList();}}></CreateUserForm>
          </Modal.Body>
        </Modal>
        <Modal show={showModifyModal} onHide={closeModifyModal}>
          <Modal.Header closeButton>
            <Modal.Title>Modifica utente</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ModifyUserForm onModify={() => {closeModifyModal(); getUsersList();}} item={modifyItem}></ModifyUserForm>
          </Modal.Body>
        </Modal>
        <ScrollView width="100%">
          {loading ? <Loader/> : error ? <Alert variation="error">Errore nel caricamento dei dati</Alert> : 
            <Table caption="" highlightOnHover={true} >
              <TableHead>
                <TableRow>
                  <TableCell as="th">Username</TableCell>
                  <TableCell as="th">Nome e cognome</TableCell>
                  <TableCell as="th">Email</TableCell>
                  <TableCell as="th">Ruolo</TableCell>
                  <TableCell as="th">Stato</TableCell>
                  <TableCell as="th"></TableCell>
                </TableRow>
              </TableHead>
                <TableBody>
                  {users?.map((item) => {
                    return (
                      <TableRow key={item.sub}>
                        <TableCell>{item.username}</TableCell>
                        <TableCell>{item.name}</TableCell>
                        <TableCell>{item.email}</TableCell>
                        <TableCell>{getUserRoleLabel(item.role)}</TableCell>
                        <TableCell>{item.enabled ? 'Attivo' : 'Bloccato'}</TableCell>
                        <TableCell>
                          <Text fontSize="24px">
                            <Icon as={MdEdit} style={{"cursor":"pointer"}} onClick={(e) => {e.stopPropagation(); setModifyItem(item); openModifyModal();}}/>
                            {item.enabled ? 
                              <Icon as={MdLock} style={{"cursor":"pointer"}} onClick={(e) => {e.stopPropagation(); blockUser(item.username)}}/> : 
                              <Icon as={MdLockOpen} style={{"cursor":"pointer"}} onClick={(e) => {e.stopPropagation(); unblockUser(item.username)}}/>  
                            }
                            <Icon as={MdAssignmentReturn} style={{"cursor":"pointer"}} onClick={() => navigate('/users/detail?user='+item.username)}/>
                          </Text>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
            </Table>
          }
        </ScrollView>
      </View>
    </View>
  );
};

export default Users;
